import {getUserId} from '../../services/user-id-helpers';

import {initRecommend} from './recommendation';

export default data => initRecommend({userId: getUserId(), ...data});
